<ng-container [ngSwitch]="dateFormat" *transloco="let translate">
    <!-- Format: dd/yyyy/MM -->
    <ng-container *ngSwitchCase="'dd/yyyy/MM'">
        <mat-form-field [class]="formFieldClass" appCustomDateFormat2 [appearance]="appearance">
            <mat-label *ngIf="label?.length > 0" [title]="label" [textContent]="label"></mat-label>
            <input
                #dateInputElement
                matInput
                tabindex="-1"
                [placeholder]="placeholder + ' ( ' + dateFormat + ' )'"
                [name]="name"
                [title]="title + ' ( ' + dateFormat + ' )'"
                [id]="id"
                [class]="classList && classList.join(' ')"
                [(ngModel)]="mannualInput"
                [errorStateMatcher]="matcher"
                [min]="minDateValue"
                [max]="maxDateValue"
                [matDatepicker]="DatePicker"
                (input)="onInput($event)"
                (blur)="!showError && onFocusOut()"
                (keyup.enter)="onKeyEnter()"
                [disabled]="disabled" />
            <material-button
                class="inline-flex items-center"
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="mannualInput || originalInput"
                [disabled]="disabled"
                tabindex="-1"
                [prefixIcon]="'close'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', 'addToIgnoreList', '!w-auto', '!px-0']"
                (buttonClicked)="$event.stopPropagation(); $event.preventDefault(); applyChangesToDate(undefined)"></material-button>
            <mat-datepicker-toggle
                class="hover:text-taxillaGreen"
                matSuffix
                [for]="DatePicker"
                [disableRipple]="disabled"></mat-datepicker-toggle>
            <mat-datepicker touchUi #DatePicker [disabled]="disabled" (closed)="onDatePickerClose()"></mat-datepicker>
            <material-button
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="description && description.length > 0"
                tabindex="-1"
                [prefixIcon]="'info'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', '!w-auto']"></material-button>
            <mat-hint align="start" *ngIf="required && errors?.length === 0 && warnings?.length === 0">
                <strong>
                    <span>*</span>
                    <span [textContent]="translate('Required')"></span>
                </strong>
            </mat-hint>
        </mat-form-field>
    </ng-container>

    <!-- Format: MM/dd/yyyy -->
    <ng-container *ngSwitchCase="'MM/dd/yyyy'">
        <mat-form-field [class]="formFieldClass" appCustomDateFormat3 [appearance]="appearance">
            <mat-label *ngIf="label?.length > 0" [title]="label" [textContent]="label"></mat-label>
            <input
                #dateInputElement
                matInput
                tabindex="-1"
                [placeholder]="placeholder + ' ( ' + dateFormat + ' )'"
                [name]="name"
                [title]="title + ' ( ' + dateFormat + ' )'"
                [id]="id"
                [class]="classList && classList.join(' ')"
                [(ngModel)]="mannualInput"
                [errorStateMatcher]="matcher"
                [min]="minDateValue"
                [max]="maxDateValue"
                [matDatepicker]="DatePicker"
                (input)="onInput($event)"
                (blur)="!showError && onFocusOut()"
                (keyup.enter)="onKeyEnter()"
                [disabled]="disabled" />
            <material-button
                class="inline-flex items-center"
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="mannualInput || originalInput"
                [disabled]="disabled"
                tabindex="-1"
                [prefixIcon]="'close'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', 'addToIgnoreList', '!w-auto', '!px-0']"
                (buttonClicked)="$event.stopPropagation(); $event.preventDefault(); applyChangesToDate(undefined)"></material-button>
            <mat-datepicker-toggle
                class="hover:text-taxillaGreen"
                matSuffix
                [for]="DatePicker"
                [disableRipple]="disabled"></mat-datepicker-toggle>
            <mat-datepicker touchUi #DatePicker [disabled]="disabled" (closed)="onDatePickerClose()"></mat-datepicker>
            <material-button
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="description && description.length > 0"
                tabindex="-1"
                [prefixIcon]="'info'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', '!w-auto']"></material-button>
            <mat-hint align="start" *ngIf="required && errors?.length === 0 && warnings?.length === 0">
                <strong>
                    <span>*</span>
                    <span [textContent]="translate('Required')"></span>
                </strong>
            </mat-hint>
        </mat-form-field>
    </ng-container>

    <!-- Format: yyyy-MM-dd -->
    <ng-container *ngSwitchCase="'yyyy-MM-dd'">
        <mat-form-field [class]="formFieldClass" appCustomDateFormat4 [appearance]="appearance">
            <mat-label *ngIf="label?.length > 0" [title]="label" [textContent]="label"></mat-label>
            <input
                #dateInputElement
                matInput
                tabindex="-1"
                [placeholder]="placeholder + ' ( ' + dateFormat + ' )'"
                [name]="name"
                [title]="title + ' ( ' + dateFormat + ' )'"
                [id]="id"
                [class]="classList && classList.join(' ')"
                [(ngModel)]="mannualInput"
                [errorStateMatcher]="matcher"
                [min]="minDateValue"
                [max]="maxDateValue"
                [matDatepicker]="DatePicker"
                (input)="onInput($event)"
                (blur)="!showError && onFocusOut()"
                (keyup.enter)="onKeyEnter()"
                [disabled]="disabled" />
            <material-button
                class="inline-flex items-center"
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="mannualInput || originalInput"
                [disabled]="disabled"
                tabindex="-1"
                [prefixIcon]="'close'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', 'addToIgnoreList', '!w-auto', '!px-0']"
                (buttonClicked)="$event.stopPropagation(); $event.preventDefault(); applyChangesToDate(undefined)"></material-button>
            <mat-datepicker-toggle
                class="hover:text-taxillaGreen"
                matSuffix
                [for]="DatePicker"
                [disableRipple]="disabled"></mat-datepicker-toggle>
            <mat-datepicker touchUi #DatePicker [disabled]="disabled" (closed)="onDatePickerClose()"></mat-datepicker>
            <material-button
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="description && description.length > 0"
                tabindex="-1"
                [prefixIcon]="'info'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', '!w-auto']"></material-button>
            <mat-hint align="start" *ngIf="required && errors?.length === 0 && warnings?.length === 0">
                <strong>
                    <span>*</span>
                    <span [textContent]="translate('Required')"></span>
                </strong>
            </mat-hint>
        </mat-form-field>
    </ng-container>

    <!-- Format: ddMMyyyy -->
    <ng-container *ngSwitchCase="'ddMMyyyy'">
        <mat-form-field [class]="formFieldClass" appCustomDateFormat5 [appearance]="appearance">
            <mat-label *ngIf="label?.length > 0" [title]="label" [textContent]="label"></mat-label>
            <input
                #dateInputElement
                matInput
                tabindex="-1"
                [placeholder]="placeholder + ' ( ' + dateFormat + ' )'"
                [name]="name"
                [title]="title + ' ( ' + dateFormat + ' )'"
                [id]="id"
                [class]="classList && classList.join(' ')"
                [(ngModel)]="mannualInput"
                [errorStateMatcher]="matcher"
                [min]="minDateValue"
                [max]="maxDateValue"
                [matDatepicker]="DatePicker"
                (input)="onInput($event)"
                (blur)="!showError && onFocusOut()"
                (keyup.enter)="onKeyEnter()"
                [disabled]="disabled" />
            <material-button
                class="inline-flex items-center"
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="mannualInput || originalInput"
                [disabled]="disabled"
                tabindex="-1"
                [prefixIcon]="'close'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', 'addToIgnoreList', '!w-auto', '!px-0']"
                (buttonClicked)="$event.stopPropagation(); $event.preventDefault(); applyChangesToDate(undefined)"></material-button>
            <mat-datepicker-toggle
                class="hover:text-taxillaGreen"
                matSuffix
                [for]="DatePicker"
                [disableRipple]="disabled"></mat-datepicker-toggle>
            <mat-datepicker touchUi #DatePicker [disabled]="disabled" (closed)="onDatePickerClose()"></mat-datepicker>
            <material-button
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="description && description.length > 0"
                tabindex="-1"
                [prefixIcon]="'info'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', '!w-auto']"></material-button>
            <mat-hint align="start" *ngIf="required && errors?.length === 0 && warnings?.length === 0">
                <strong>
                    <span>*</span>
                    <span [textContent]="translate('Required')"></span>
                </strong>
            </mat-hint>
        </mat-form-field>
    </ng-container>

    <!-- Format: dd-MM-yyyy -->
    <ng-container *ngSwitchCase="'dd-MM-yyyy'">
        <mat-form-field [class]="formFieldClass" appCustomDateFormat6 [appearance]="appearance">
            <mat-label *ngIf="label?.length > 0" [title]="label" [textContent]="label"></mat-label>
            <input
                #dateInputElement
                matInput
                tabindex="-1"
                [placeholder]="placeholder + ' ( ' + dateFormat + ' )'"
                [name]="name"
                [title]="title + ' ( ' + dateFormat + ' )'"
                [id]="id"
                [class]="classList && classList.join(' ')"
                [(ngModel)]="mannualInput"
                [errorStateMatcher]="matcher"
                [min]="minDateValue"
                [max]="maxDateValue"
                [matDatepicker]="DatePicker"
                (input)="onInput($event)"
                (blur)="!showError && onFocusOut()"
                (keyup.enter)="onKeyEnter()"
                [disabled]="disabled" />
            <material-button
                class="inline-flex items-center"
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="mannualInput || originalInput"
                [disabled]="disabled"
                tabindex="-1"
                [prefixIcon]="'close'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', 'addToIgnoreList', '!w-auto', '!px-0']"
                (buttonClicked)="$event.stopPropagation(); $event.preventDefault(); applyChangesToDate(undefined)"></material-button>
            <mat-datepicker-toggle
                class="hover:text-taxillaGreen"
                matSuffix
                [for]="DatePicker"
                [disableRipple]="disabled"></mat-datepicker-toggle>
            <mat-datepicker touchUi #DatePicker [disabled]="disabled" (closed)="onDatePickerClose()"></mat-datepicker>
            <material-button
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="description && description.length > 0"
                tabindex="-1"
                [prefixIcon]="'info'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', '!w-auto']"></material-button>
            <mat-hint align="start" *ngIf="required && errors?.length === 0 && warnings?.length === 0">
                <strong>
                    <span>*</span>
                    <span [textContent]="translate('Required')"></span>
                </strong>
            </mat-hint>
        </mat-form-field>
    </ng-container>

    <!-- Format: dd-mm-yyyy -->
    <ng-container *ngSwitchCase="'dd-mm-yyyy'">
        <mat-form-field [class]="formFieldClass" appCustomDateFormat6 [appearance]="appearance">
            <mat-label *ngIf="label?.length > 0" [title]="label" [textContent]="label"></mat-label>
            <input
                #dateInputElement
                matInput
                tabindex="-1"
                [placeholder]="placeholder + ' ( ' + dateFormat + ' )'"
                [name]="name"
                [title]="title + ' ( ' + dateFormat + ' )'"
                [id]="id"
                [class]="classList && classList.join(' ')"
                [(ngModel)]="mannualInput"
                [errorStateMatcher]="matcher"
                [min]="minDateValue"
                [max]="maxDateValue"
                [matDatepicker]="DatePicker"
                (input)="onInput($event)"
                (blur)="!showError && onFocusOut()"
                (keyup.enter)="onKeyEnter()"
                [disabled]="disabled" />
            <material-button
                class="inline-flex items-center"
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="mannualInput || originalInput"
                [disabled]="disabled"
                tabindex="-1"
                [prefixIcon]="'close'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', 'addToIgnoreList', '!w-auto', '!px-0']"
                (buttonClicked)="$event.stopPropagation(); $event.preventDefault(); applyChangesToDate(undefined)"></material-button>
            <mat-datepicker-toggle
                class="hover:text-taxillaGreen"
                matSuffix
                [for]="DatePicker"
                [disableRipple]="disabled"></mat-datepicker-toggle>
            <mat-datepicker touchUi #DatePicker [disabled]="disabled" (closed)="onDatePickerClose()"></mat-datepicker>
            <material-button
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="description && description.length > 0"
                tabindex="-1"
                [prefixIcon]="'info'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', '!w-auto']"></material-button>
            <mat-hint align="start" *ngIf="required && errors?.length === 0 && warnings?.length === 0">
                <strong>
                    <span>*</span>
                    <span [textContent]="translate('Required')"></span>
                </strong>
            </mat-hint>
        </mat-form-field>
    </ng-container>

    <!-- Format: dd-MMM-yyyy -->
    <ng-container *ngSwitchCase="'dd-MMM-yyyy'">
        <mat-form-field [class]="formFieldClass" appCustomDateFormat7 [appearance]="appearance">
            <mat-label *ngIf="label?.length > 0" [title]="label" [textContent]="label"></mat-label>
            <input
                #dateInputElement
                matInput
                tabindex="-1"
                [placeholder]="placeholder + ' ( ' + dateFormat + ' )'"
                [name]="name"
                [title]="title + ' ( ' + dateFormat + ' )'"
                [id]="id"
                [class]="classList && classList.join(' ')"
                [(ngModel)]="mannualInput"
                [errorStateMatcher]="matcher"
                [min]="minDateValue"
                [max]="maxDateValue"
                [matDatepicker]="DatePicker"
                (input)="onInput($event)"
                (blur)="!showError && onFocusOut()"
                (keyup.enter)="onKeyEnter()"
                [disabled]="disabled" />
            <material-button
                class="inline-flex items-center"
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="mannualInput || originalInput"
                [disabled]="disabled"
                tabindex="-1"
                [prefixIcon]="'close'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', 'addToIgnoreList', '!w-auto', '!px-0']"
                (buttonClicked)="$event.stopPropagation(); $event.preventDefault(); applyChangesToDate(undefined)"></material-button>
            <mat-datepicker-toggle
                class="hover:text-taxillaGreen"
                matSuffix
                [for]="DatePicker"
                [disableRipple]="disabled"></mat-datepicker-toggle>
            <mat-datepicker touchUi #DatePicker [disabled]="disabled" (closed)="onDatePickerClose()"></mat-datepicker>
            <material-button
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="description && description.length > 0"
                tabindex="-1"
                [prefixIcon]="'info'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', '!w-auto']"></material-button>
            <mat-hint align="start" *ngIf="required && errors?.length === 0 && warnings?.length === 0">
                <strong>
                    <span>*</span>
                    <span [textContent]="translate('Required')"></span>
                </strong>
            </mat-hint>
        </mat-form-field>
    </ng-container>

    <!-- Format: yyyy/dd/MM -->
    <ng-container *ngSwitchCase="'yyyy/dd/MM'">
        <mat-form-field [class]="formFieldClass" appCustomDateFormat8 [appearance]="appearance">
            <mat-label *ngIf="label?.length > 0" [title]="label" [textContent]="label"></mat-label>
            <input
                #dateInputElement
                matInput
                tabindex="-1"
                [placeholder]="placeholder + ' ( ' + dateFormat + ' )'"
                [name]="name"
                [title]="title + ' ( ' + dateFormat + ' )'"
                [id]="id"
                [class]="classList && classList.join(' ')"
                [(ngModel)]="mannualInput"
                [errorStateMatcher]="matcher"
                [min]="minDateValue"
                [max]="maxDateValue"
                [matDatepicker]="DatePicker"
                (input)="onInput($event)"
                (blur)="!showError && onFocusOut()"
                (keyup.enter)="onKeyEnter()"
                [disabled]="disabled" />
            <material-button
                class="inline-flex items-center"
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="mannualInput || originalInput"
                [disabled]="disabled"
                tabindex="-1"
                [prefixIcon]="'close'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', 'addToIgnoreList', '!w-auto', '!px-0']"
                (buttonClicked)="$event.stopPropagation(); $event.preventDefault(); applyChangesToDate(undefined)"></material-button>
            <mat-datepicker-toggle
                class="hover:text-taxillaGreen"
                matSuffix
                [for]="DatePicker"
                [disableRipple]="disabled"></mat-datepicker-toggle>
            <mat-datepicker touchUi #DatePicker [disabled]="disabled" (closed)="onDatePickerClose()"></mat-datepicker>
            <material-button
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="description && description.length > 0"
                tabindex="-1"
                [prefixIcon]="'info'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', '!w-auto']"></material-button>
            <mat-hint align="start" *ngIf="required && errors?.length === 0 && warnings?.length === 0">
                <strong>
                    <span>*</span>
                    <span [textContent]="translate('Required')"></span>
                </strong>
            </mat-hint>
        </mat-form-field>
    </ng-container>

    <!-- Format: MM-yyyy-dd -->
    <ng-container *ngSwitchCase="'MM-yyyy-dd'">
        <mat-form-field [class]="formFieldClass" appCustomDateFormat9 [appearance]="appearance">
            <mat-label *ngIf="label?.length > 0" [title]="label" [textContent]="label"></mat-label>
            <input
                #dateInputElement
                matInput
                tabindex="-1"
                [placeholder]="placeholder + ' ( ' + dateFormat + ' )'"
                [name]="name"
                [title]="title + ' ( ' + dateFormat + ' )'"
                [id]="id"
                [class]="classList && classList.join(' ')"
                [(ngModel)]="mannualInput"
                [errorStateMatcher]="matcher"
                [min]="minDateValue"
                [max]="maxDateValue"
                [matDatepicker]="DatePicker"
                (input)="onInput($event)"
                (blur)="!showError && onFocusOut()"
                (keyup.enter)="onKeyEnter()"
                [disabled]="disabled" />
            <material-button
                class="inline-flex items-center"
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="mannualInput || originalInput"
                [disabled]="disabled"
                tabindex="-1"
                [prefixIcon]="'close'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', 'addToIgnoreList', '!w-auto', '!px-0']"
                (buttonClicked)="$event.stopPropagation(); $event.preventDefault(); applyChangesToDate(undefined)"></material-button>
            <mat-datepicker-toggle
                class="hover:text-taxillaGreen"
                matSuffix
                [for]="DatePicker"
                [disableRipple]="disabled"></mat-datepicker-toggle>
            <mat-datepicker touchUi #DatePicker [disabled]="disabled" (closed)="onDatePickerClose()"></mat-datepicker>
            <material-button
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="description && description.length > 0"
                tabindex="-1"
                [prefixIcon]="'info'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', '!w-auto']"></material-button>
            <mat-hint align="start" *ngIf="required && errors?.length === 0 && warnings?.length === 0">
                <strong>
                    <span>*</span>
                    <span [textContent]="translate('Required')"></span>
                </strong>
            </mat-hint>
        </mat-form-field>
    </ng-container>

    <!-- Format: yyyy/MM/dd -->
    <ng-container *ngSwitchCase="'yyyy/MM/dd'">
        <mat-form-field [class]="formFieldClass" appCustomDateFormat10 [appearance]="appearance">
            <mat-label *ngIf="label?.length > 0" [title]="label" [textContent]="label"></mat-label>
            <input
                #dateInputElement
                matInput
                tabindex="-1"
                [placeholder]="placeholder + ' ( ' + dateFormat + ' )'"
                [name]="name"
                [title]="title + ' ( ' + dateFormat + ' )'"
                [id]="id"
                [class]="classList && classList.join(' ')"
                [(ngModel)]="mannualInput"
                [errorStateMatcher]="matcher"
                [min]="minDateValue"
                [max]="maxDateValue"
                [matDatepicker]="DatePicker"
                (input)="onInput($event)"
                (blur)="!showError && onFocusOut()"
                (keyup.enter)="onKeyEnter()"
                [disabled]="disabled" />
            <material-button
                class="inline-flex items-center"
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="mannualInput || originalInput"
                [disabled]="disabled"
                tabindex="-1"
                [prefixIcon]="'close'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', 'addToIgnoreList', '!w-auto', '!px-0']"
                (buttonClicked)="$event.stopPropagation(); $event.preventDefault(); applyChangesToDate(undefined)"></material-button>
            <mat-datepicker-toggle
                class="hover:text-taxillaGreen"
                matSuffix
                [for]="DatePicker"
                [disableRipple]="disabled"></mat-datepicker-toggle>
            <mat-datepicker touchUi #DatePicker [disabled]="disabled" (closed)="onDatePickerClose()"></mat-datepicker>
            <material-button
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="description && description.length > 0"
                tabindex="-1"
                [prefixIcon]="'info'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', '!w-auto']"></material-button>
            <mat-hint align="start" *ngIf="required && errors?.length === 0 && warnings?.length === 0">
                <strong>
                    <span>*</span>
                    <span [textContent]="translate('Required')"></span>
                </strong>
            </mat-hint>
        </mat-form-field>
    </ng-container>

    <!-- Format: yyyy-dd-MM -->
    <ng-container *ngSwitchCase="'yyyy-dd-MM'">
        <mat-form-field [class]="formFieldClass" appCustomDateFormat11 [appearance]="appearance">
            <mat-label *ngIf="label?.length > 0" [title]="label" [textContent]="label"></mat-label>
            <input
                #dateInputElement
                matInput
                tabindex="-1"
                [placeholder]="placeholder + ' ( ' + dateFormat + ' )'"
                [name]="name"
                [title]="title + ' ( ' + dateFormat + ' )'"
                [id]="id"
                [class]="classList && classList.join(' ')"
                [(ngModel)]="mannualInput"
                [errorStateMatcher]="matcher"
                [min]="minDateValue"
                [max]="maxDateValue"
                [matDatepicker]="DatePicker"
                (input)="onInput($event)"
                (blur)="!showError && onFocusOut()"
                (keyup.enter)="onKeyEnter()"
                [disabled]="disabled" />
            <material-button
                class="inline-flex items-center"
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="mannualInput || originalInput"
                [disabled]="disabled"
                tabindex="-1"
                [prefixIcon]="'close'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', 'addToIgnoreList', '!w-auto', '!px-0']"
                (buttonClicked)="$event.stopPropagation(); $event.preventDefault(); applyChangesToDate(undefined)"></material-button>
            <mat-datepicker-toggle
                class="hover:text-taxillaGreen"
                matSuffix
                [for]="DatePicker"
                [disableRipple]="disabled"></mat-datepicker-toggle>
            <mat-datepicker touchUi #DatePicker [disabled]="disabled" (closed)="onDatePickerClose()"></mat-datepicker>
            <material-button
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="description && description.length > 0"
                tabindex="-1"
                [prefixIcon]="'info'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', '!w-auto']"></material-button>
            <mat-hint align="start" *ngIf="required && errors?.length === 0 && warnings?.length === 0">
                <strong>
                    <span>*</span>
                    <span [textContent]="translate('Required')"></span>
                </strong>
            </mat-hint>
        </mat-form-field>
    </ng-container>

    <!-- Format: dd-yyyy-MM -->
    <ng-container *ngSwitchCase="'dd-yyyy-MM'">
        <mat-form-field [class]="formFieldClass" appCustomDateFormat12 [appearance]="appearance">
            <mat-label *ngIf="label?.length > 0" [title]="label" [textContent]="label"></mat-label>
            <input
                #dateInputElement
                matInput
                tabindex="-1"
                [placeholder]="placeholder + ' ( ' + dateFormat + ' )'"
                [name]="name"
                [title]="title + ' ( ' + dateFormat + ' )'"
                [id]="id"
                [class]="classList && classList.join(' ')"
                [(ngModel)]="mannualInput"
                [errorStateMatcher]="matcher"
                [min]="minDateValue"
                [max]="maxDateValue"
                [matDatepicker]="DatePicker"
                (input)="onInput($event)"
                (blur)="!showError && onFocusOut()"
                (keyup.enter)="onKeyEnter()"
                [disabled]="disabled" />
            <material-button
                class="inline-flex items-center"
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="mannualInput || originalInput"
                [disabled]="disabled"
                tabindex="-1"
                [prefixIcon]="'close'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', 'addToIgnoreList', '!w-auto', '!px-0']"
                (buttonClicked)="$event.stopPropagation(); $event.preventDefault(); applyChangesToDate(undefined)"></material-button>
            <mat-datepicker-toggle
                class="hover:text-taxillaGreen"
                matSuffix
                [for]="DatePicker"
                [disableRipple]="disabled"></mat-datepicker-toggle>
            <mat-datepicker touchUi #DatePicker [disabled]="disabled" (closed)="onDatePickerClose()"></mat-datepicker>
            <material-button
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="description && description.length > 0"
                tabindex="-1"
                [prefixIcon]="'info'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', '!w-auto']"></material-button>
            <mat-hint align="start" *ngIf="required && errors?.length === 0 && warnings?.length === 0">
                <strong>
                    <span>*</span>
                    <span [textContent]="translate('Required')"></span>
                </strong>
            </mat-hint>
        </mat-form-field>
    </ng-container>

    <!-- Format: MM-dd-yyyy -->
    <ng-container *ngSwitchCase="dateFormat === 'MM-dd-yyyy' || dateFormat === 'mm-dd-yyyy' ? dateFormat : ''">
        <mat-form-field [class]="formFieldClass" appCustomDateFormat13 [appearance]="appearance">
            <mat-label *ngIf="label?.length > 0" [title]="label" [textContent]="label"></mat-label>
            <input
                #dateInputElement
                matInput
                tabindex="-1"
                [placeholder]="placeholder + ' ( ' + dateFormat + ' )'"
                [name]="name"
                [title]="title + ' ( ' + dateFormat + ' )'"
                [id]="id"
                [class]="classList && classList.join(' ')"
                [(ngModel)]="mannualInput"
                [errorStateMatcher]="matcher"
                [min]="minDateValue"
                [max]="maxDateValue"
                [matDatepicker]="DatePicker"
                (input)="onInput($event)"
                (blur)="!showError && onFocusOut()"
                (keyup.enter)="onKeyEnter()"
                [disabled]="disabled" />
            <material-button
                class="inline-flex items-center"
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="mannualInput || originalInput"
                [disabled]="disabled"
                tabindex="-1"
                [prefixIcon]="'close'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', 'addToIgnoreList', '!w-auto', '!px-0']"
                (buttonClicked)="$event.stopPropagation(); $event.preventDefault(); applyChangesToDate(undefined)"></material-button>
            <mat-datepicker-toggle
                class="hover:text-taxillaGreen"
                matSuffix
                [for]="DatePicker"
                [disableRipple]="disabled"></mat-datepicker-toggle>
            <mat-datepicker touchUi #DatePicker [disabled]="disabled" (closed)="onDatePickerClose()"></mat-datepicker>
            <material-button
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="description && description.length > 0"
                tabindex="-1"
                [prefixIcon]="'info'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', '!w-auto']"></material-button>
            <mat-hint align="start" *ngIf="required && errors?.length === 0 && warnings?.length === 0">
                <strong>
                    <span>*</span>
                    <span [textContent]="translate('Required')"></span>
                </strong>
            </mat-hint>
        </mat-form-field>
    </ng-container>

    <!-- Format: MM/yyyy/dd -->
    <ng-container *ngSwitchCase="'MM/yyyy/dd'">
        <mat-form-field [class]="formFieldClass" appCustomDateFormat14 [appearance]="appearance">
            <mat-label *ngIf="label?.length > 0" [title]="label" [textContent]="label"></mat-label>
            <input
                #dateInputElement
                matInput
                tabindex="-1"
                [placeholder]="placeholder + ' ( ' + dateFormat + ' )'"
                [name]="name"
                [title]="title + ' ( ' + dateFormat + ' )'"
                [id]="id"
                [class]="classList && classList.join(' ')"
                [(ngModel)]="mannualInput"
                [errorStateMatcher]="matcher"
                [min]="minDateValue"
                [max]="maxDateValue"
                [matDatepicker]="DatePicker"
                (input)="onInput($event)"
                (blur)="!showError && onFocusOut()"
                (keyup.enter)="onKeyEnter()"
                [disabled]="disabled" />
            <material-button
                class="inline-flex items-center"
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="mannualInput || originalInput"
                [disabled]="disabled"
                tabindex="-1"
                [prefixIcon]="'close'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', 'addToIgnoreList', '!w-auto', '!px-0']"
                (buttonClicked)="$event.stopPropagation(); $event.preventDefault(); applyChangesToDate(undefined)"></material-button>
            <mat-datepicker-toggle
                class="hover:text-taxillaGreen"
                matSuffix
                [for]="DatePicker"
                [disableRipple]="disabled"></mat-datepicker-toggle>
            <mat-datepicker touchUi #DatePicker [disabled]="disabled" (closed)="onDatePickerClose()"></mat-datepicker>
            <material-button
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="description && description.length > 0"
                tabindex="-1"
                [prefixIcon]="'info'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', '!w-auto']"></material-button>
            <mat-hint align="start" *ngIf="required && errors?.length === 0 && warnings?.length === 0">
                <strong>
                    <span>*</span>
                    <span [textContent]="translate('Required')"></span>
                </strong>
            </mat-hint>
        </mat-form-field>
    </ng-container>

    <!-- Format: yyyyMMdd -->
    <ng-container *ngSwitchCase="'yyyyMMdd'">
        <mat-form-field [class]="formFieldClass" appCustomDateFormat15 [appearance]="appearance">
            <mat-label *ngIf="label?.length > 0" [title]="label" [textContent]="label"></mat-label>
            <input
                #dateInputElement
                matInput
                tabindex="-1"
                [placeholder]="placeholder + ' ( ' + dateFormat + ' )'"
                [name]="name"
                [title]="title + ' ( ' + dateFormat + ' )'"
                [id]="id"
                [class]="classList && classList.join(' ')"
                [(ngModel)]="mannualInput"
                [errorStateMatcher]="matcher"
                [min]="minDateValue"
                [max]="maxDateValue"
                [matDatepicker]="DatePicker"
                (input)="onInput($event)"
                (blur)="!showError && onFocusOut()"
                (keyup.enter)="onKeyEnter()"
                [disabled]="disabled" />
            <material-button
                class="inline-flex items-center"
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="mannualInput || originalInput"
                [disabled]="disabled"
                tabindex="-1"
                [prefixIcon]="'close'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', 'addToIgnoreList', '!w-auto', '!px-0']"
                (buttonClicked)="$event.stopPropagation(); $event.preventDefault(); applyChangesToDate(undefined)"></material-button>
            <mat-datepicker-toggle
                class="hover:text-taxillaGreen"
                matSuffix
                [for]="DatePicker"
                [disableRipple]="disabled"></mat-datepicker-toggle>
            <mat-datepicker touchUi #DatePicker [disabled]="disabled" (closed)="onDatePickerClose()"></mat-datepicker>
            <material-button
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="description && description.length > 0"
                tabindex="-1"
                [prefixIcon]="'info'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', '!w-auto']"></material-button>
            <mat-hint align="start" *ngIf="required && errors?.length === 0 && warnings?.length === 0">
                <strong>
                    <span>*</span>
                    <span [textContent]="translate('Required')"></span>
                </strong>
            </mat-hint>
        </mat-form-field>
    </ng-container>

    <!-- Format: default -->
    <ng-container *ngSwitchDefault>
        <mat-form-field [class]="formFieldClass" appDefaultDateFormat [appearance]="appearance">
            <mat-label *ngIf="label?.length > 0" [title]="label" [textContent]="label"></mat-label>
            <input
                #dateInputElement
                matInput
                tabindex="-1"
                [placeholder]="placeholder + ' ( ' + dateFormat + ' )'"
                [name]="name"
                [title]="title + ' ( ' + dateFormat + ' )'"
                [id]="id"
                [class]="classList && classList.join(' ')"
                [(ngModel)]="mannualInput"
                [errorStateMatcher]="matcher"
                [min]="minDateValue"
                [max]="maxDateValue"
                [matDatepicker]="DatePicker"
                (input)="onInput($event)"
                (blur)="!showError && onFocusOut()"
                (keyup.enter)="onKeyEnter()"
                [disabled]="disabled" />
            <material-button
                class="inline-flex items-center"
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="mannualInput || originalInput"
                [disabled]="disabled"
                tabindex="-1"
                [prefixIcon]="'close'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', 'addToIgnoreList', '!w-auto', '!px-0']"
                (buttonClicked)="$event.stopPropagation(); $event.preventDefault(); applyChangesToDate(undefined)"></material-button>
            <mat-datepicker-toggle
                class="hover:text-taxillaGreen"
                matSuffix
                [for]="DatePicker"
                [disableRipple]="disabled"></mat-datepicker-toggle>
            <mat-datepicker touchUi #DatePicker [disabled]="disabled" (closed)="onDatePickerClose()"></mat-datepicker>
            <material-button
                buttonType="icon"
                [size]="'small'"
                matSuffix
                *ngIf="description && description.length > 0"
                tabindex="-1"
                [prefixIcon]="'info'"
                [prefixIconType]="'material'"
                [titleText]="description"
                [classList]="['fieldDescInfoIcon', '!w-auto']"></material-button>
            <mat-hint align="start" *ngIf="required && errors?.length === 0 && warnings?.length === 0">
                <strong>
                    <span>*</span>
                    <span [textContent]="translate('Required')"></span>
                </strong>
            </mat-hint>
        </mat-form-field>
    </ng-container>
    <ng-container *ngIf="errors?.length !== 0 || warnings?.length !== 0">
        <mat-error class="text-[10px] leading-[10px]" *ngIf="errors?.length > 0" [title]="errors[0]" [textContent]="errors[0]"></mat-error>
        <mat-error
            class="text-[10px] leading-[10px]"
            [class.mat-has-warning]="warnings?.length > 0"
            *ngIf="errors?.length === 0 && warnings?.length > 0"
            [title]="warnings[0]"
            [textContent]="warnings[0]"></mat-error>
    </ng-container>
</ng-container>
